'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Autogenerated by Thrift Compiler (0.9.3-airbnb12)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
var PropTypes = process.env.NODE_ENV === 'production' ? null : require('prop-types');

var Operation = exports.Operation = {
  Impression: 1,
  Click: 2,
  Show: 3,
  Select: 4,
  Focus: 5,
  Toggle: 6,
  Cache: 7,
  Schedule: 8,
  Dismiss: 9,
  Scroll: 10,
  Swipe: 11,
  Update: 12,
  Save: 13,
  Delete: 14,
  Move: 15,
  Enter: 16,
  Submit: 17,
  Blur: 18,
  ReduxAction: 19,
  Pixel: 20,
  Keypress: 21,
  Drag: 22,
  Search: 23,
  Clear: 24,
  Accept: 25,
  Decline: 26,
  Zoom: 27,
  Autofill: 28
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-jitney-schemas/logging_type_operation_v1.js
// module id = 459
// module chunks = 168707334958949